<template>
  <div class="member">
    <h1>會員專區</h1>
    <div class="member__container">
      <div class="member__body">
        <ul class="member__list">
          <li class="member__item">
            <div class="mCollapse">
              <div class="mCollapse__header">
                <a href="#"
                  class="mCollapse__header"
                  :class="infoCollapse ? null : 'collapsed'"
                  @click.prevent="infoCollapse = !infoCollapse"
                >
                  會員資料
                </a>
              </div>
              <b-collapse v-model="infoCollapse">
                <div class="mCollapse__body">
                  <editable-text-block
                  :title="'姓名'"
                  :k="'name'"
                  :value="member.name"
                  :type="'text'"
                  @emit_newValue='change_member_info'
                  ></editable-text-block>
                  <editable-text-block
                  :title="'生日'"
                  :k="'birthday'"
                  :value="member.birthday"
                  :type="'date'"
                  @emit_newValue='change_member_info'
                  ></editable-text-block>
                  <editable-text-block
                  :title="'電話'"
                  :k="'tel'"
                  :value="member.tel"
                  :type="'text'"
                  @emit_newValue='change_member_info'
                  ></editable-text-block>
                  <editable-text-block
                  :title="'Email'"
                  :k="'email'"
                  :value="member.email"
                  :type="'email'"
                  @emit_newValue='change_member_info'
                  ></editable-text-block>
                  <editable-text-block
                  :title="'密碼'"
                  :k="'password'"
                  :value="member.password"
                  :type="'password'"
                  @emit_newValue='change_member_info'
                  ></editable-text-block>
                </div>
              </b-collapse>
            </div>
          </li>
          <li class="member__item">
            <div class="mCollapse">
              <div class="mCollapse__header">
                <a href="#"
                  class="mCollapse__header"
                  :class="orderCollapse ? null : 'collapsed'"
                  @click.prevent="orderCollapse = !orderCollapse"
                >訂單查詢</a>
              </div>
              <b-collapse v-model="orderCollapse">
                <div class="mCollapse__body">
                  <order-collapse
                  :member='member'
                  :orders='orders'
                  ></order-collapse>
                </div>
              </b-collapse>
            </div>
          </li>
          <li class="member__item">
            <div class="mCollapse">
              <div class="mCollapse__header">
                <a href="#"
                  class="mCollapse__header"
                  :class="favoriteCollapse ? null : 'collapsed'"
                  @click.prevent="favoriteCollapse = !favoriteCollapse">
                  喜好項目
                </a>
              </div>
              <b-collapse v-model="favoriteCollapse">
                <div class="mCollapse__body">
                  <div class="mFavorite">
                    <div class="mFavorite__container">
                      <div class="mFavorite__block"
                      v-for="(item, index) in memberFavoriteArr"
                      :key="index">
                        <a href="#" class="mFavorite__a"
                        @click='go_page(`/front/onlinestore/all/${item.id}`)'>
                          <div class="mFavorite__img">
                            <img :src="item.images.main" alt="">
                          </div>
                          <div class="mFavorite__body">
                            <p class="mFavorite__title">{{item.title}}</p>
                            <p class="mFavorite__id">{{item.id}}</p>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </li>
          <li class="member__item">
            <div class="mCollapse">
              <div class="mCollapse__header">
                <a href="#"
                  class="mCollapse__header"
                  :class="mailCollapse ? null : 'collapsed'"
                  @click.prevent="mailCollapse = !mailCollapse">
                  信件匣
                </a>
              </div>
              <b-collapse v-model="mailCollapse">
                <div class="mCollapse__body">
                  <div class="w-100"
                  v-for="(item, index) in memberMails"
                  :key="index">
                    <b-button
                      :variant='item.read? "success" : "secondary"'
                      v-b-toggle="item.id"
                      class="my-1 w-100 d-flex flex-wrap align-items-center">
                        <span class="col-12 col-md-4 pb-2 pb-md-0">
                          {{item.name}}
                        </span>
                        <span class="col-12 col-md-4  pb-2 pb-md-0">
                          {{convert_time(item.time)}}
                        </span>
                        <span class="col-12 col-md-4 ">
                          {{item.read? '*已讀' : '未讀'}}
                        </span>
                    </b-button>
                    <b-collapse :id="item.id">
                      <b-card>
                        <div class="card-body p-0 d-flex flex-column flex-md-row">
                          <h6 class="card-title
                          text-md-right pr-md-3">
                          寄件人</h6>
                          <div class="card-text mb-3 mb-md-0">
                            {{item.name}}
                          </div>
                        </div>
                        <div class="card-body p-0 d-flex flex-column flex-md-row">
                          <h6 class="card-title
                          text-md-right pr-md-3">
                          寄件日期</h6>
                          <div class="card-text mb-3 mb-md-0">
                            {{convert_time(item.time)}}
                          </div>
                        </div>
                        <div class="card-body p-0 d-flex flex-column flex-md-row">
                          <h6 class="card-title
                          text-md-right pr-md-3">
                          連絡電話</h6>
                          <div class="card-text mb-3 mb-md-0">
                            {{item.tel}}
                          </div>
                        </div>
                        <div class="card-body p-0 d-flex flex-column flex-md-row">
                          <h6 class="card-title
                          text-md-right pr-md-3">
                          連絡email</h6>
                          <div class="card-text mb-3 mb-md-0">
                            {{item.mail}}
                          </div>
                        </div>
                        <div class="card-body p-0 d-flex flex-column flex-md-row">
                          <h6 class="card-title
                          text-md-right pr-md-3">
                          信件內容</h6>
                          <div class="card-text mb-3 mb-md-0" v-html="item.content"></div>
                        </div>
                        <hr>
                        <div class="card-body p-0 d-flex flex-column flex-md-row"
                        v-if="item.reply.id !== ''">
                          <h6 class="card-title
                          text-md-right pr-md-3">
                          回覆人</h6>
                          <div class="card-text mb-3 mb-md-0">{{item.reply.name}}</div>
                        </div>
                        <div class="card-body p-0 d-flex flex-column flex-md-row"
                        v-if="item.reply.id !== ''">
                          <h6 class="card-title
                          text-md-right pr-md-3">
                          回覆時間</h6>
                          <div class="card-text mb-3 mb-md-0">
                            {{convert_time(item.reply.time)}}
                          </div>
                        </div>
                        <div class="card-body p-0 d-flex flex-column flex-md-row"
                        v-if="item.reply.id !== ''">
                          <h6 class="card-title
                          text-md-right pr-md-3">
                          回覆內容</h6>
                          <div class="card-text mb-3 mb-md-0"
                          v-html="item.reply.content">
                          </div>
                        </div>
                        <div class="card-body p-0 d-flex flex-column flex-md-row"
                        v-if="item.reply.id === ''">
                          <h6 class="card-title
                          text-md-right pr-md-3">
                          尚未回覆</h6>
                        </div>
                      </b-card>
                    </b-collapse>
                  </div>
                </div>
              </b-collapse>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import EditableTextBlock from '../../components/EditableTextBlock.vue';
import OrderCollapse from '../../components/OrderCollapse.vue';

export default {
  components: { EditableTextBlock, OrderCollapse },
  computed: {
    member() {
      let member;
      this.$bus.$on('son_get_data', (data) => {
        member = data.member;
      });
      this.$bus.$emit('son_call_data');
      return member;
    },
    products() {
      let arr = [];
      this.$bus.$on('son_get_data', (data) => {
        arr = data.products;
      });
      this.$bus.$emit('son_call_data');
      return arr;
    },
    memberFavoriteArr() {
      const arr = [];
      this.member.favorites.forEach((fItem) => {
        const f = this.products.find((item) => item.id === fItem);
        arr.push(f);
      });
      return arr;
    },
    orders() {
      let arr = [];
      this.$bus.$on('son_get_data', (data) => {
        arr = data.orders;
      });
      this.$bus.$emit('son_call_data');
      return arr;
    },
    memberMails() {
      let arr = [];
      let mails = [];
      this.$bus.$on('son_get_data', (data) => {
        mails = data.mails;
      });
      this.$bus.$emit('son_call_data');
      arr = mails.filter((item) => item.id.includes(this.member.id));
      return arr;
    },
  },
  data() {
    return {
      infoCollapse: true,
      orderCollapse: true,
      favoriteCollapse: true,
      mailCollapse: true,
    };
  },
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
    change_member_info(key, value) {
      this.member[key] = value;
    },
    convert_time(time) {
      const formatDate = new Date(JSON.parse(time));
      const covertTimeText = (d) => {
        const year = d.getFullYear();
        const month = d.getMonth() + 1;
        const day = d.getDate();
        return `${year} 年 ${month} 月 ${day} 日`;
      };
      return covertTimeText(formatDate);
    },
  },
  created() {
    this.$bus.$emit('toggleCart', false);
  },
};
</script>
